import { motion } from "motion/react";
import { t } from "@/lib/i18n";
import type { ContactSection as ContactData } from "@/data/profile";
import type { SectionProps } from "../types";
import { SectionFrame } from "../SectionFrame";

export function ContactSection({ section, number, ctx }: SectionProps<ContactData>) {
  const { lang, copied, copy, presets } = ctx;
  const { cta } = section;
  const label = copied ? t(cta.doneLabel, lang) : t(cta.label, lang);

  const onClick = () => {
    if (cta.action.kind === "copy") copy(cta.action.value);
    else if (cta.action.kind === "link") window.open(cta.action.href, "_blank", "noopener");
  };

  return (
    <SectionFrame number={number} kicker={section.kicker} title={section.title} ctx={ctx}>
      <motion.p
        variants={presets.rise(0.16)}
        style={{ fontSize: 17, lineHeight: 1.6, color: "var(--tc-muted)", marginBottom: 22, maxWidth: 520, textWrap: "pretty" }}
      >
        {t(section.body, lang)}
      </motion.p>

      <motion.button
        type="button"
        onClick={onClick}
        variants={presets.rise(0.22)}
        whileHover={{ backgroundColor: "var(--tc-brass)" }}
        whileTap={{ scale: 0.97 }}
        style={{
          cursor: "pointer",
          fontFamily: "var(--tc-mono)",
          fontSize: 13,
          letterSpacing: "0.04em",
          color: "var(--tc-paper)",
          background: "var(--tc-ink)",
          border: "none",
          borderRadius: 999,
          padding: "13px 24px",
        }}
      >
        {label}
      </motion.button>
    </SectionFrame>
  );
}
